import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import VideoThumbnail from '../assets/images/home/video_thumbnail.jpg';
import PettiImage from '../assets/images/home/petti.jpg';
import LoungeImage from '../assets/images/home/lounge.jpg';
import PettiDesktop from '../assets/images/about/petti.webp';
import PettiMobile from '../assets/images/about/petti_mo.jpg';
import PettiSmall from '../assets/images/about/petti_sm.jpg';
import BbkDesktop from '../assets/images/about/bbk.webp';
import BbkMobile from '../assets/images/about/bbk_mo.jpg';
import BbkSmall from '../assets/images/about/bbk_sm.jpg';
import KentDesktop from '../assets/images/about/kent.webp';
import KentMobile from '../assets/images/about/kent_mo.jpg';
import KentSmall from '../assets/images/about/kent_sm.jpg';

// External stylesheets
const stylesheets = [
  'https://fonts.googleapis.com/css?family=Jost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CAmiri%3Aregular%2Citalic%2C700%2C700italic%7CAllison%3Aregular&subset=cyrillic%2Clatin%2Clatin-ext%2Carabic%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css?family=Oswald%3A200%2C300%2Cregular%2C500%2C600%2C700%7CMerriweather%3A300%2C300italic%2Cregular%2Citalic%2C700%2C700italic%2C900%2C900italic%7CJost%3A100%2C200%2C300%2Cregular%2C500%2C600%2C700%2C800%2C900%2C100italic%2C200italic%2C300italic%2Citalic%2C500italic%2C600italic%2C700italic%2C800italic%2C900italic%7CMontserrat%3A100%2C100italic%2C200%2C200italic%2C300%2C300italic%2Cregular%2Citalic%2C500%2C500italic%2C600%2C600italic%2C700%2C700italic%2C800%2C800italic%2C900%2C900italic%7CAllison%3Aregular&subset=cyrillic%2Ccyrillic-ext%2Clatin%2Clatin-ext%2Cvietnamese&ver=6.0.1',
  'https://fonts.googleapis.com/css2?family=Boogaloo&family=Lato:wght@100;300;400;900&display=swap',
  'https://fonts.googleapis.com/css2?family=Handlee&family=Neucha&family=Pacifico&family=Patrick+Hand&family=Patrick+Hand+SC&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Sacramento&display=swap',
  'https://fonts.googleapis.com/css2?family=Yellowtail&display=swap',
  '/pettipetti/css/bootstrap.min.css',
  '/bbmirissa/css/style.css',
  '/pettipetti/css/secondary/style.css',
  '/pettipetti/css/vendors.min.css',
  '/pettipetti/css/custom.css',
];

const Aboutus = () => {
  return (
    <>
      {stylesheets.map((href, index) => (
        <link key={index} rel="stylesheet" href={href} type="text/css" media="all" />
      ))}
      <title>About Us | Banana Bunks Mirissa | Oryza Leisure</title>
      <div
        className="home page-template-default page page-id-15043 theme-hotale gdlr-core-body tourmaster-body woocommerce-no-js hotale-body hotale-body-front hotale-full hotale-with-sticky-navigation hotale-blockquote-style-3 gdlr-core-link-to-lightbox"
        data-home-url=""
      >
        <Navbar />
        <div className="hotale-page-title-wrap hotale-style-custom hotale-center-align">
          <div className="hotale-header-transparent-substitute"></div>
          <div className="hotale-page-title-overlay"></div>
          <div className="hotale-page-title-container hotale-container">
            <div className="hotale-page-title-content hotale-item-pdlr">
              <h1 className="hotale-page-title hotale-additional-font"><b>About Us</b></h1>
            </div>
          </div>
        </div>

        <div className="hotale-page-wrapper" id="hotale-page-wrapper">
          <div className="gdlr-core-page-builder-body">
            <div className="gdlr-core-pbf-wrapper" style={{ padding: '0px 0px 0px 0px' }} id="gdlr-core-wrapper-3">
              <div className="gdlr-core-pbf-background-wrap">
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js bbmirissabg">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-60 gdlr-core-column-first" id="gdlr-core-column-8">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '0px 0px 0px 0px', padding: '40px 90px 0px 0px' }}>
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js green_back_about">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '20px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test hotale-additional-font" style={{ fontSize: '45px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none' }}>
                                Bunks By The Beach<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-divider-item gdlr-core-divider-item-normal gdlr-core-item-pdlr gdlr-core-left-align">
                            <div className="gdlr-core-divider-container" style={{ maxWidth: '54px' }}>
                              <div className="gdlr-core-divider-line gdlr-core-skin-divider" style={{ borderColor: '#eeb85e', borderWidth: '5px' }}></div>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '22px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ fontSize: '20px', textTransform: 'none' }}>
                              <p>Brought by popular demand, Banana Bunks Mirissa is the sister property of Banana Bunks Kandy and are the exclusive rooms for Petti Petti Mirissa. In contrast to the bustling beach club and restaurant, we have made sure that the room environment dive into a tropical wonderland. It came naturally for the rooms to feel like secluded luxury, thus it has been garnished with diverse greenery. As you’ll soon find out, this proves to be an experience in itself!</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper videopadding" id="gdlr-core-wrapper-6">
              <div className="gdlr-core-pbf-background-wrap">
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js">
                  <img className="vid_pic" src={VideoThumbnail} alt="" />
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper secspacing bbmirissabg" id="gdlr-core-wrapper-6">
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-element" style={{ paddingTop: '40px' }}>
                    <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" id="gdlr-core-title-item-1">
                      <div className="gdlr-core-title-item-title-wrap green_back_second">
                        <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{ fontSize: '65px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}>
                          Make every moment count<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                        </h3>
                        <div className="lower-text">Together with our restaurant Petti Petti Mirissa, we offer a range of activities and lounge spaces for the most scenic vacation</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="gdlr-core-pbf-wrapper bbmirissabg" style={{ padding: '0px 0px 63px 0px' }} id="gdlr-core-wrapper-7">
              <div className="gdlr-core-pbf-background-wrap"></div>
              <div className="gdlr-core-pbf-background-wrap" style={{ top: '-10px' }}>
                <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
              </div>
              <div className="gdlr-core-pbf-wrapper-content gdlr-core-js">
                <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                  <div className="gdlr-core-pbf-column gdlr-core-column-36 gdlr-core-column-first" id="gdlr-core-column-20">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ borderRadius: '20px 20px 20px 20px' }}>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round" style={{ borderWidth: '0px', borderRadius: '20px' }}>
                              <img src={PettiImage} alt="" width="1300" height="716" title="chef-cook" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-24" id="gdlr-core-column-21">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js facipadding">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js green_back_second">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" style={{ paddingBottom: '35px' }}>
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test greencolor" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '0px', lineHeight: 1.6, textTransform: 'none' }}>
                                Specials Offers<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '20px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ fontSize: '18px', fontWeight: 400, textTransform: 'none' }}>
                              <p>In-house guests at Banana Bunks gets 25% off on all food and non-alcoholic beverages at our restaurant! It’s a great way to explore Petti Petti’s flavor packed menu.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-36 allphone" id="gdlr-core-column-23">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '40px 0px 0px 0px', borderRadius: '20px 20px 20px 20px' }}>
                      <div className="gdlr-core-pbf-background-wrap" style={{ borderRadius: '20px 20px 20px 20px' }}>
                        <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js"></div>
                      </div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round" style={{ borderWidth: '0px', borderRadius: '20px' }}>
                              <img src={LoungeImage} alt="" width="1300" height="716" title="bar" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-24 gdlr-core-column-first" id="gdlr-core-column-22">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js poolpadding">
                      <div className="gdlr-core-pbf-background-wrap"></div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js green_back_second">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr">
                            <div className="gdlr-core-title-item-title-wrap">
                              <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test greencolor" style={{ fontSize: '30px', fontWeight: 500, letterSpacing: '0px', lineHeight: 1.6, textTransform: 'none' }}>
                                Lounge Area<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                              </h3>
                            </div>
                          </div>
                        </div>
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-text-box-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-left-align" style={{ paddingBottom: '20px' }}>
                            <div className="gdlr-core-text-box-item-content" style={{ fontSize: '18px', fontWeight: 400, textTransform: 'none' }}>
                              <p>
                                Looking for a hang-out spot?<br />Our lounge area doubles as chill spot and work-space for guests who are working on the go. Shaded using local hay, the lounge sets the scene for all travelers!
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="gdlr-core-pbf-column gdlr-core-column-36 desktopview" id="gdlr-core-column-23">
                    <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '110px 0px 0px 0px', borderRadius: '20px 20px 20px 20px' }}>
                      <div className="gdlr-core-pbf-background-wrap" style={{ borderRadius: '20px 20px 20px 20px' }}>
                        <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js" style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}></div>
                      </div>
                      <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                        <div className="gdlr-core-pbf-element">
                          <div className="gdlr-core-image-item gdlr-core-item-pdb gdlr-core-center-align gdlr-core-item-pdlr" style={{ paddingBottom: '0px' }}>
                            <div className="gdlr-core-image-item-wrap gdlr-core-media-image gdlr-core-image-item-style-round" style={{ borderWidth: '0px', borderRadius: '20px' }}>
                              <img src={LoungeImage} alt="" width="1300" height="716" title="bar" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="gdlr-core-pbf-wrapper-content gdlr-core-js" style={{ backgroundColor: '#585550', paddingBottom: '50px' }}>
              <div className="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
                <div className="gdlr-core-pbf-element" style={{ paddingTop: '40px' }}>
                  <div className="gdlr-core-title-item gdlr-core-item-pdb clearfix gdlr-core-center-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr" id="gdlr-core-title-item-1">
                    <div className="gdlr-core-title-item-title-wrap green_back_second">
                      <h3 className="gdlr-core-title-item-title gdlr-core-skin-title class-test" style={{ fontSize: '65px', fontWeight: 400, letterSpacing: '0px', textTransform: 'none', color: '#eeb85e' }}>
                        Explore Oryza Leisure destinations in Sri Lanka<span className="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="gdlr-core-pbf-column gdlr-core-column-first" id="gdlr-core-column-9" style={{ width: '100%', float: 'left' }}>
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '15px 15px 15px 15px', padding: '285px 0px 30px 0px', borderRadius: '15px 15px 15px 15px' }}>
                    <div className="gdlr-core-pbf-background-wrap" style={{ borderRadius: '15px 15px 15px 15px' }}>
                      <img className="desktopview" src={PettiDesktop} alt="" />
                      <img className="mobileview" src={PettiMobile} alt="" />
                      <img className="smallphone" src={PettiSmall} alt="" />
                    </div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                          <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border" href="/PettiPettiMirissa" style={{ fontSize: '15px', fontStyle: 'normal', fontWeight: 500, letterSpacing: '0px', color: '#eeb85e', padding: '14px 36px 14px 36px', textTransform: 'none', borderRadius: '15px', background: '#585550' }}>
                            <span className="gdlr-core-content">Petti Petti Mirissa</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="gdlr-core-pbf-column gdlr-core-column-20 gdlr-core-column-first" id="gdlr-core-column-11">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '15px 15px 15px 15px', padding: '285px 0px 30px 0px', borderRadius: '15px 15px 15px 15px' }}>
                    <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#161616', borderRadius: '15px 15px 15px 15px' }}>
                      <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js">
                        <img className="desktopview" src={BbkDesktop} alt="" />
                        <img className="mobileview" src={BbkMobile} alt="" />
                        <img className="smallphone" src={BbkSmall} alt="" />
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                          <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border" href="/BananaBunksKandy" style={{ fontSize: '15px', fontStyle: 'normal', fontWeight: 500, letterSpacing: '0px', color: '#eeb85e', padding: '14px 36px 14px 36px', textTransform: 'none', borderRadius: '15px', background: '#585550' }}>
                            <span className="gdlr-core-content">Banana Bunks Kandy</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="gdlr-core-pbf-column gdlr-core-column-40" id="gdlr-core-column-12">
                  <div className="gdlr-core-pbf-column-content-margin gdlr-core-js" style={{ margin: '15px 15px 15px 15px', padding: '285px 0px 30px 0px', borderRadius: '15px 15px 15px 15px' }}>
                    <div className="gdlr-core-pbf-background-wrap" style={{ backgroundColor: '#0a0a0a', borderRadius: '15px 15px 15px 15px' }}>
                      <div className="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js">
                        <img className="desktopview" src={KentDesktop} alt="" />
                        <img className="mobileview" src={KentMobile} alt="" />
                        <img className="smallphone" src={KentSmall} alt="" />
                      </div>
                    </div>
                    <div className="gdlr-core-pbf-column-content clearfix gdlr-core-js">
                      <div className="gdlr-core-pbf-element">
                        <div className="gdlr-core-button-item gdlr-core-item-pdlr gdlr-core-item-pdb gdlr-core-center-align" style={{ paddingBottom: '0px' }}>
                          <a className="gdlr-core-button gdlr-core-button-solid gdlr-core-center-align gdlr-core-button-no-border" href="/Kent" style={{ fontSize: '15px', fontStyle: 'normal', fontWeight: 500, letterSpacing: '0px', color: '#eeb85e', padding: '14px 36px 14px 36px', textTransform: 'none', borderRadius: '15px', background: '#585550' }}>
                            <span className="gdlr-core-content">Kent Cottage</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </>
  );
};

export default Aboutus;